export enum TableColumnType {
  STRING,
  TRANSLATION,
  ACTION,
  ENUM,
  DATE,
}
